import { render, staticRenderFns } from "./FacialIllustration.vue?vue&type=template&id=2493d724&"
import script from "./FacialIllustration.vue?vue&type=script&lang=js&"
export * from "./FacialIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports